import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Data Fields", href: "/data-fields", current: true },
];
export default function DataFields() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="data-fields">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}